import React, {Fragment, useState, useEffect} from "react";

import {Row, Col} from "react-bootstrap";
import {useTranslation} from 'react-i18next';
import Cookies from 'js-cookie';
import OmantelVisaHeader from './OmantelVisaHeader';
function OmantelOrderFailed() {

    const {t} = useTranslation();

    const [orderData, setOrderData] = useState(false);
    useEffect(() => {
        // debugger;
        const storedOrderString = sessionStorage.getItem('orderResult');
        if (storedOrderString) {
            const storedOrder = JSON.parse(storedOrderString);
            setOrderData(storedOrder);
        }
    }, []);


    const urlSearchString = window.location.search;

    const uparams = new URLSearchParams(urlSearchString);

    const failStyle = {
        display: "inline-block",
        position: "relative",
        border: "5em solid currentColor",
        borderRadius: "50%",
        fontSize: "0.4px",
        width: "50em",
        height: "50em",
        color: "#e27d7a",

    };

    const beforeAfterStyle = {
        content: '""',
        width: "5em",
        height: "34em",
        position: "absolute",
        left: "50%",
        top: "50%",
        marginTop: "-17em",
        marginLeft: "-2em",
        backgroundColor: "currentColor",
        borderRadius: "3px",
    };

    const beforeStyle = {
        ...beforeAfterStyle,
        transform: "rotate(45deg)",
    };

    const afterStyle = {
        ...beforeAfterStyle,
        transform: "rotate(-45deg)",
    };


    return (
        <>
        <OmantelVisaHeader />
                <div className="container">
                <div style={{height:"80vh",alignContent:"center"}}>
                    <Row className="justify-content-center align-items-center">
                        <Col md={6} className="text-center">
                            <div style={{...failStyle, fontSize: "1.5px"}}>
                                <span style={beforeStyle}/>
                                <span style={afterStyle}/>
                            </div>
                            <div>
                                <h3 style={{textAlign: 'center'}}>
                                    Payment Failed
                                </h3>
                            </div>
                        </Col>
                    </Row>
                    </div>


                </div>
        
        </>
    );
}

export default OmantelOrderFailed;